<div class="card mapa-comparativo-card p-4 mb-4">
  <h5 class="card-title">Mapa Comparativo</h5>

  <div class="filtros d-flex mb-4 ">
    <div class="d-flex filtros-mapa">
      <app-filtro-responsavel
        [responsavel]="responsavel"
        [(filtroResponsavel)]="selectedUsuario"
        (responsavelIdChange)="onResponsavelIdChange($event)"
        (responsavelLimpo)="onResponsavelIdChange(0)"
      ></app-filtro-responsavel>

      <app-filtro-periodo
        [(intervaloSelecionado)]="selectedPeriodo"
        [config]="config"
        (intervaloSelecionadoChange)="onPeriodoSelecionadoChange($event)"
      ></app-filtro-periodo>
    </div>

    <button type="button" class="btn btn-dark" (click)="exportExcel()" [disabled]="desabilitarExportar">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/agenda-tarefas/download.svg"
        width="20"
        height="20"
        alt="Exportar"
      />
      EXPORTAR
    </button>
  </div>

  <div class="table-responsive table-container mt-3 tabela-scroll-mobile">
    <table class="table table-hover align-middle table-scroll">
      <thead class="head-table">
        <tr>
          <th>
            <input
              type="checkbox"
              [checked]="todosSelecionados()"
              (change)="toggleSelecionarTodos($event)"
              style="margin-right: 6px"
            />
            Responsável
          </th>
          <th>
            Última Atividade
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarUltimaAtividade()"
              title="Ordenar por data"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Acessos
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('access')"
              title="Ordenar por acessos"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Buscas
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('search')"
              title="Ordenar por buscas"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Prospecção
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('prospecting')"
              title="Ordenar por prospecção"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Contratadas
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('contracted')"
              title="Ordenar por contratadas"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Perdidas
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('lost')"
              title="Ordenar por perdidas"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
          <th>
            Ações
            <button
              type="button"
              class="btn btn-link p-0 ms-1"
              (click)="ordenarColuna('actions')"
              title="Ordenar por ações"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/agenda-tarefas/order.svg"
                alt="ordenar"
                width="16"
                height="16"
              />
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let c of comparativos"
          [class.nao-selecionado]="selecionados.length > 0 && !c.selected"
        >
          <td [ngClass]="c.selected ? 'coluna-identificacao-selecionada' : ''">
            <input
              type="checkbox"
              [(ngModel)]="c.selected"
              style="margin-right: 8px"
            />
            {{ c.responsibleName }}
          </td>

          <td [ngClass]="c.selected ? 'coluna-identificacao-selecionada' : ''">
            {{ c.lastActivity }}
          </td>

          <td [ngClass]="getComparativoClass(c, 'access')">{{ c.access }}</td>
          <td [ngClass]="getComparativoClass(c, 'search')">{{ c.search }}</td>
          <td [ngClass]="getComparativoClass(c, 'prospecting')">
            {{ c.prospecting }}
          </td>
          <td [ngClass]="getComparativoClass(c, 'contracted')">
            {{ c.contracted }}
          </td>
          <td [ngClass]="getComparativoClass(c, 'lost')">{{ c.lost }}</td>
          <td [ngClass]="getComparativoClass(c, 'actions')">{{ c.actions }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-modal-aguardando-download
  *ngIf="processandoAcao"
  [mensagem]="mensagemProcessando"
></app-modal-aguardando-download>
